export function hasQuiz(
  contentBlocksGroups: Array<{ content: ContentBlock[] }>,
): boolean {
  return contentBlocksGroups.some((group) =>
    group.content.some((block) => block.type === "quiz"),
  );
}

export function isQuizAnswered(
  block: ContentBlock,
  quizzes: RoadmapStepQuizProgressVM[] | undefined,
): boolean {
  if (block.type !== "quiz" || !quizzes) {
    return false;
  }
  return quizzes.some((q) => q.questionUuid === block.data.uuid);
}
